import { z } from 'zod';
import { timeframeSchema } from './timeframe.js';
const pointSchema = z.object({
    time: z.number().int().nonnegative(),
    price: z.number().finite().positive(),
});
export const teachingFibInputSchema = z.object({
    symbol: z.string().min(1).max(32),
    timeframe: timeframeSchema,
    start: pointSchema,
    end: pointSchema,
    note: z.string().max(500).default(''),
});
export const teachingFibPatchSchema = z.object({
    start: pointSchema.optional(),
    end: pointSchema.optional(),
    note: z.string().max(500).optional(),
});
/** Direction follows from the two prices; it is never stored separately. */
export function swingDirection(start, end) {
    return end.price >= start.price ? 'up' : 'down';
}
//# sourceMappingURL=teachingFib.js.map